import type * as GraphQLTypes from '../../../graphql/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IgnorePackageNotificationMutationVariables = GraphQLTypes.Exact<{
  paymentId: GraphQLTypes.Scalars['String'];
  type: GraphQLTypes.Scalars['String'];
}>;


export type IgnorePackageNotificationMutationResult = (
  { __typename?: 'Mutation' }
  & Pick<GraphQLTypes.Mutation, 'ignorePackageNotification'>
);


export const IgnorePackageNotificationDocument = /*#__PURE__*/ gql`
    mutation ignorePackageNotification($paymentId: String!, $type: String!) {
  ignorePackageNotification(paymentId: $paymentId, type: $type)
}
    `;

/**
 * __useIgnorePackageNotificationMutation__
 *
 * To run a mutation, you first call `useIgnorePackageNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnorePackageNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignorePackageNotificationMutation, { data, loading, error }] = useIgnorePackageNotificationMutation({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useIgnorePackageNotificationMutation(baseOptions?: Apollo.MutationHookOptions<IgnorePackageNotificationMutationResult, IgnorePackageNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnorePackageNotificationMutationResult, IgnorePackageNotificationMutationVariables>(IgnorePackageNotificationDocument, options);
      }
export type IgnorePackageNotificationMutationHookResult = ReturnType<typeof useIgnorePackageNotificationMutation>;